module.exports = __webpack_public_path__ + "img/dark.3877c0b2.svg";